import { Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  token : any = null
  
  constructor() { }

  saveToken(token : string){
    localStorage.setItem('token' , token )
  }

  getToken(){
    return localStorage.getItem('token')
  }

  removeToken(){
    localStorage.removeItem('token')
  }

  isValidToken(){
    const token = this.getToken()
    if(!token ){
      return false
    }
    if(token === 'undefined'){
      return false
    }
    const decodeToken = jwtDecode(token)
    this.token = decodeToken
    

    
    if(this.token.authmethod != "pwd"){
      return false
    }
    if(decodeToken && decodeToken?.exp){
      const tokenDate = new Date(0)
      tokenDate.setUTCSeconds(decodeToken.exp)
      const currentDate = new Date() 
      return tokenDate.getTime() > currentDate.getTime()
    }
    return false
  }



}
